import { date_dmy_func, } from "../../../../components/Common/CommonFunction";
import { amountCommaSeparateFunc } from "../../../../components/Common/CommonFunction";

// original
export const Item =(itemCount) => [
    { header: "HSN\nRate", dataKey: "HSN" },
    { header: `Item(${itemCount})\nGST%/Dis.Amt/\nDis.Value`, dataKey: "ItemName" },
    { header: "Qty\nAmount", dataKey: "Amount" },
];


export const GSTDetails = [
    "Total CGST",
    "Total SGST",
    "Total GGST",
];

export const Details = [
    "Details",
]

export const Discription = [
    "Discription",
]



// TableData.js
export const ItemRow = (data) => {
    const rows = [];

    data.forEach(element => {
        const qty = `${element.Quantity} ${element.PrimaryUnitName || ""}`;
        const Amount = `${amountCommaSeparateFunc(Number(element.Amount).toFixed(2))}`;

         const hasDiscount = Number(element.DiscountAmount) > 0 || Number(element.Discount) > 0;
    const discountText = hasDiscount
        ? `/${element.DiscountAmount}/${Number(element.Discount).toFixed(2)}%`
        : "";

        // ✅ Parent row
        rows.push({
            type: "parent",
            cells: [
                `${element.HSNCode}\n${element.MRPValue}`,
                `${element.ItemName}\n${Number(element.GSTPercentage).toFixed(2)}%${discountText}`,
                `${qty}\n${Amount}`
            ]
        });

        // ✅ Child row (collapsed into one line)
        if (element.MixItems && element.MixItems.length > 0) {
            const childLine = element.MixItems.map(child => {
                const childQty = `${child.Quantity} ${child.PrimaryUnitName || ""}`;
                return `${child.ItemName} (${childQty})`;
            }).join(" | ");

            rows.push({
                type: "child",
                cells: [childLine]
            });
        }
    });

    return rows.map(r => r.cells);
};


export const GSTDetailsRow = (data, doc) => {

    const { InvoiceItems = [] } = data

    let totalCGST = 0
    let totalSGST = 0
    InvoiceItems.forEach(arg => {
        totalCGST += Number(arg.CGST);
        totalSGST += Number(arg.SGST);
    });
    const Total_GST = Number(totalCGST) + Number(totalSGST)

    const tableitemRow = [[
        `${Number(totalCGST).toFixed(2)}`,
        `${Number(totalSGST).toFixed(2)}`,
        `${Number(Total_GST).toFixed(2)}`,
    ]

    ];

    return tableitemRow
}

export const DetailsRow = (data) => {
    var DetailsArray = [
        // [`${data.CompanyName}`],
        [`${data.PartyName}`],
        [`------------Tax Invoice---------`],
        [`${data.PartyAddress} Ph.${data.AlternateContactNo}`],
        [`GSTIN:${data.PartyGSTIN}`],
        [`Customer:${data.CustomerName}   GSTIN:${data.CustomerGSTIN}`],
        [`Customer Ph.${data.CustomerMobileNo}`],
        [`Date:${date_dmy_func(data.InvoiceDate)}   ${data?.CreatedOn?.slice(11)}              Bill No:${data.FullInvoiceNumber}`],
    ]
    if (data.CustomerGSTIN === "") {
        DetailsArray.splice(5, 1);
    }
    return DetailsArray;
}


export const DiscriptionRow = (data) => {
    var discriptionArray = [
        [`We hereby certify that food/foods mentioned in this invoice is/are warranted to be the nature & quality when it/this purport to be at the time of delivery. Kindly consume sweets immediately. Goods once sold will not be taken back`],
        [`FSSAI:${data.PartyFSSAINo}`]
    ]
    return discriptionArray;
}
